/*
Example state:

export default {
  byId: {
    ans1: {
      id: 'ans1',
      name: 'Can you guess who is NOT cool?',
      content: {
        public: {
          bodyHtml: 'Jdom is not cool.',
        },
      },
    },
    ans2: {
      id: 'ans2',
      name: 'Can you guess who IS cool?',
      content: {
        public: {
          bodyHtml: 'Kaylee is cool.',
        },
      },
    },
    ans3: {
      id: 'ans3',
      name: 'Can you guess who IS also cool?',
      content: {
        public: {
          bodyHtml: 'Someone is also cool.',
        },
      },
    },
    ans4: {
      id: 'ans4',
      name: 'Can you think of more words words words words words words?',
      content: {
        public: {
          bodyHtml: 'Blaah blaah blaah.',
        },
      },
    },
    ans5: {
      id: 'ans5',
      name: 'Can you say some stuff?',
      content: {
        public: {
          bodyHtml: 'Okay.',
        },
      },
    },
    ans6: {
      id: 'ans6',
      name: 'Can adsf asdjkfh alskdjfh',
      content: {
        public: {
          bodyHtml: 'adfhakj flkjh',
        },
      },
    },
    ans7: {
      id: 'ans7',
      name: 'Can lsadjfh sdlfj',
      content: {
        public: {
          bodyHtml: 'sldfkjhad fkhd',
        },
      },
    },
    ans8: {
      id: 'ans8',
      name: 'Can werkhdfjk hsdfjkh',
      content: {
        public: {
          bodyHtml: 'Probably not.',
        },
      },
    },
  },
  allIds: ['ans1', 'ans2', 'ans3', 'ans4', 'ans5', 'ans6', 'ans7', 'ans8'],
  searchResultAnswerIds: ['ans1', 'ans2', 'ans3', 'ans4', 'ans5', 'ans6', 'ans7', 'ans8'],
  searchResults: [],
  selectedAnswer: null,
};

*/

export default {
  byId: {},
  allIds: [],
  searchResultAnswerIds: [],
  searchResults: [],
  selectedAnswer: null,
};
